import './TournamentsList.css'
import { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { useCallback } from 'react'

import { ReactComponent as Arrow } from '../../icon/arrow-follow.svg'

const TournamentsListComponent = (props) => {
	const navigate = useNavigate()
	const [tournamentsList, setTournamentsList] = useState([])

	useEffect(() => {
		if (props?.list?.length > 0) {
			const sortedListByDate = [...props?.list].sort((a, b) => {
				return dayjs(b.start_date).isAfter(a.start_date) ? 1 : -1
			})

			const sortedListByType = sortedListByDate.sort((a, b) => {
				if (a.status === 'not_yet_started' && b.status !== 'not_yet_started') {
					return -1
				} else if (a.status !== 'not_yet_started' && b.status === 'not_yet_started') {
					return 1
				} else {
					return 0
				}
			})

			setTournamentsList(sortedListByType)
		} else {
			setTournamentsList([])
		}
	}, [props?.list])

	const setColor = useCallback((period, condition) => {
		if (dayjs(period).isAfter(dayjs()) && condition === 'not_yet_started') {
			return '#FFBD2D'
		} else if (dayjs(period).isBefore(dayjs()) && condition === 'started') {
			return '#00D83C'
		} else if (dayjs(period).isSame(dayjs()) && condition === 'started') {
			return '#00D83C'
		} else {
			return '#894ABA'
		}
	}, [props?.list])

	const handleCategory = useCallback((item) => {
		const category = props?.data?.categories.filter(el => {
			return item?.category_uid === el.uid
		})

		return category[0]?.name
	}, [props?.list])

	const formatDate = useCallback((date) => {
		const parts = date.split('-')

		return `${parts[2]}.${parts[1]}.${parts[0]}`
	}, [props?.list])

	console.log(props?.list, props?.data)

	return (
		<div className="tournaments-list">
			{
				tournamentsList?.map((item, index) => (
					<div key={index} className="list-card">
						<div className="card__container" onClick={() => { navigate(`/${item.uid}`) }}>
							<div className="card__content">
								<div className="card__head">
									<p
										className="card__period"
										style={{
											color: setColor(item.start_date, item.status)
										}}
									>
										{formatDate(item.start_date)}
									</p>

									<p className="card__category">
										{handleCategory(item)}
									</p>
								</div>

								<p className="card__name">
									{item.name}
								</p>
							</div>

							<Arrow className="card__icon" />
						</div>
					</div>
				))
			}
		</div>
	)
}

export const TournamentsList = memo(TournamentsListComponent)
